import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import times from 'lodash/times';

import UserList from '../components/UserList';
import SearchUsersForm from '../components/SearchUsersForm';
import { getSearchUsers, getPageCount, getLoggedInUser } from '../reducers';
import { getUsersApiOptions, searchUsers } from '../actions/users';

class SearchUsers extends Component {
  state = {
    wasSearched: false,
    searchValues: {},
    loading: false,
    userTypes: [],
  };
  componentDidMount() {
    this.loadUserTypes();
  }

  componentDidUpdate(oldProps) {
    const { searchValues } = this.state;
    if (oldProps.page !== this.props.page) {
      try {
        this.handleSearch(searchValues);
      } catch (e) {
        console.log(e);
      }
    }

    if (!oldProps.loggedInUser && this.props.loggedInUser) {
      this.loadUserTypes();
    }
  }

  loadUserTypes = () => {
    const { loggedInUser } = this.props;
    if (!loggedInUser) {
      return;
    }

    getUsersApiOptions()
      .then((res) => {
        if (res.error) {
          toast.error('Failed to load user types');
        }

        const { choices } = res.acl_group_name;
        const userTypes = choices.map(({ value }) => [value, value]);
        // always include logged in user type
        if (
          !userTypes.find((option) => option[0] === loggedInUser.acl_group_name)
        ) {
          userTypes.push([
            loggedInUser.acl_group_name,
            loggedInUser.acl_group_name,
          ]);
        }

        this.setState({
          userTypes,
        });
      })
      .catch(() => {
        toast.error('Failed to load user types');
      });
  };

  handleSearch = (values, resetPage) => {
    const { searchUsers, page } = this.props;

    this.setState({ loading: true });
    if (resetPage && page?.toString() !== '1') {
      this.setState({ searchValues: values });
      this.props.history.push('/users/search');
      return;
    }

    return searchUsers(page, values).then(() => {
      this.setState({
        wasSearched: true,
        searchValues: values,
        loading: false,
      });
    });
  };

  render() {
    const { wasSearched, loading, userTypes } = this.state;
    const { users, pageCount, page } = this.props;

    return (
      <div>
        <h1>Search Users</h1>
        <SearchUsersForm
          userTypes={userTypes}
          onSubmit={(values) => this.handleSearch(values, true)}
        />
        <br />
        {!loading && users && users.length > 0 && <UserList users={users} />}
        {loading && <div>Loading...</div>}
        {wasSearched && !loading && users && users.length === 0 && (
          <div>No results</div>
        )}
        {!loading && (
          <nav aria-label="Page navigation">
            <ul className="pagination">
              {pageCount > 1 &&
                times(pageCount, (pageNum) => {
                  pageNum += 1;
                  return (
                    <li
                      key={pageNum}
                      className={pageNum === parseInt(page, 10) ? 'active' : ''}
                    >
                      <Link to={`/users/search/page/${pageNum}`}>
                        {pageNum}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </nav>
        )}
      </div>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { page = 1 },
    },
  },
) => ({
  loggedInUser: getLoggedInUser(state),
  users: getSearchUsers(state, page),
  pageCount: getPageCount(state, 'users', `searchUsers`, page),
  page,
});

const mapDispatchToProps = {
  searchUsers,
};

SearchUsers = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchUsers),
);

export default SearchUsers;
